<template>
  <div :class="['bs-wizard-info']">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "bs-wizard-info",
  props: {}
};
</script>

<style>
.bs-wizard > .bs-wizard-step .bs-wizard-info {
  color: #999;
  font-size: 12px;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/BsWizard/BsWizardInfo.vue